///<reference path="app/ChosekiDoc.ts"/>

(function() {
	document.addEventListener("DOMContentLoaded", () => {
		new app.ChosekiDoc();
	});
})();

